// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"a12dc24a","513":"ee2671ed","703":"133871ca","787":"489983ce"}[chunkId] + ".chunk.js";
};